import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Breadcrumbs from 'components/Common/Breadcrumb';
import DataTable from "../../components/Common/LocalizedDataTable";
import { CouponCodeApi } from "apis/CouponCodeApi";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import config from "config/config";
import Swal from "../../helpers/swal_helper";
import moment from "moment";
import { formatNumber } from "../../helpers/language_helper";

function CouponCodes(props) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeData, setActiveData] = useState({
        page: 1,
        totalPage: 1,
        search: "",
        limit: config.LIMIT,
    });

    useEffect(() => {
        getAllCouponCodes(activeData);
    }, []);

    const columns = [{
        name: props.t("Sr.No"),
        selector: row => row.id,
        cell: row => formatNumber(row.id),
        sortable: true,
    }, {
        name: props.t("Code"),
        selector: row => row.code,
        sortable: true
    }, {
        name: props.t("Discount Type"),
        selector: row => row.discount_type,
        sortable: true
    }, {
        name: props.t("Amount"),
        selector: row => row.amount,
        sortable: true
    }, {
        name: props.t("Valid From"),
        selector: row => row.valid_from,
        sortable: true
    }, {
        name: props.t("Valid To"),
        selector: row => row.valid_to,
        sortable: true
    }, {
        name: props.t("Status"),
        selector: row => row.status ? props.t("Active") : props.t("Inactive"),
        sortable: true,
        cell: row => (
            <span style={{
                color: row.status ? '#28a745' : '#dc3545',
                fontWeight: '500'
            }}>
                {row.status ? props.t("Active") : props.t("Inactive")}
            </span>
        )
    }, {
        name: props.t("Action"),
        selector: row => row.action
    }];

    const getAllCouponCodes = (data) => {
        setLoading(true);
        CouponCodeApi.getAllCouponCodes(data)
            .then((res) => {
                if (res.data.status) {
                    setActiveData({
                        ...activeData,
                        totalPage: res.data.pagination.total,
                    });
                    let tableData = [];
                    res.data.data.forEach((v, i) => {
                        tableData[i] = {
                            id: i+1,
                            code: v.code,
                            discount_type: v.discount_type,
                            amount: v.amount,
                            valid_from: moment(v.valid_from).format("DD MMM Y"),
                            valid_to: moment(v.valid_to).format("DD MMM Y"),
                            status: v.status,
                            action: (
                                <>
                                    <Link
                                        style={{ marginRight: "15px" }}
                                        to={`/edit-coupon-code/${v.id}`}
                                    >
                                        <i className="fas fa-edit" id="edittooltip" />
                                    </Link>
                                    <i className="mdi mdi-delete font-size-18" style={{ color: "red" }} id="deletetooltip" onClick={() => onDelete(v.id)} />
                                </>
                            ),
                        };
                    });
                    setData(tableData);
                } else {
                    Swal.fire({
                        title: "Error",
                        text: res.data.message,
                        icon: "error",
                    });
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                Swal.fire({
                    title: "Error",
                    text: "Failed to fetch coupon codes",
                    icon: "error",
                });
            });
    };

    const onDelete = (id) => {
        Swal.fire({
            title: props.t("Are you sure?"),
            text: props.t("You won't be able to revert this!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: props.t("Yes, delete it!"),
            cancelButtonText: props.t("Cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                CouponCodeApi.deleteCouponCode({coupon_id : id})
                    .then((res) => {
                        if (res.data.status) {
                            Swal.fire("Deleted!", res.data.message, "success");
                            getAllCouponCodes(activeData);
                        } else {
                            Swal.fire("Error!", res.data.message, "error");
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        Swal.fire("Error!", "Failed to delete coupon code", "error");
                    });
            }
        });
    };

    const handleChange = (page) => {
        const updatedData = { ...activeData, page };
        setActiveData(updatedData);
        getAllCouponCodes(updatedData);
    }

    const handleRowChange = (limit) => {
        const updatedData = { ...activeData, limit };
        setActiveData(updatedData);
        getAllCouponCodes(updatedData);
    }

    //meta title
    document.title = props.t("Coupon Codes") + ' | ' + props.t("Salon");

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title={props.t("Dashboard")} breadcrumbItem={props.t("Coupon Codes")} />
                <Link to="/add-coupon-code" className="btn btn-primary w-xs btn-right">{props.t("Add")}</Link>
            </div>

            <div className="container-fluid">
                <DataTable
                    className="table-bordered"
                    progressPending={loading}
                    columns={columns}
                    data={data}
                    pagination
                    paginationServer
                    paginationTotalRows={activeData.totalPage}
                    paginationPerPage={activeData.limit}
                    defaultSortFieldID={1}
                    onChangeRowsPerPage={value => handleRowChange(value)}
                    onChangePage={value => handleChange(value)}
                    sortable
                    noHeader
                    defaultSortField="id"
                    defaultSortAsc={false}
                    highlightOnHover
                />
            </div>
        </div>
    );
}

CouponCodes.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(CouponCodes); 